import { PaginatedResponse } from "@cawita/core-front/api";
import { OperatorFunction } from "rxjs";
import { map } from "rxjs/operators";

export function mapArrayToPaginated<D>(): OperatorFunction<PaginatedResponse<D> | D[], PaginatedResponse<D>> {
    return (src) => src.pipe(map(res => {
        if (Array.isArray(res)) return {
            data: res,
            total: res.length,
            limit: res.length,
            isPaginated: true,
            page: 0,
        };
        return res;
    }));
}